import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Host,
    Input,
    OnInit,
    Output,
} from "@angular/core"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-user-profile-checkbox",
    templateUrl: "./user-profile-checkbox.component.html",
    styleUrls: ["./user-profile-checkbox.component.scss"],
    standalone: false,
})
export class UserProfileCheckboxComponent implements OnInit {
    @Input() value: string
    @Input() label: string
    @Input() isChecked: boolean

    @Input() gtmClass: string = ""

    @Input()
    set isDisabled(disabled) {
        this.disabled = disabled
        this.cd.detectChanges()
    }

    @Output() clicked: EventEmitter<string> = new EventEmitter<string>()

    id = ""
    disabled = false

    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.id = Utils.generateUniqueId()
    }

    isClicked(value: string) {
        this.clicked.emit(value)
    }
}
